module.exports = __webpack_public_path__ + "static/media/analytics.aa0c129b.svg";